import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { BlogProvider } from '../../context/BlogContext';
import { BlogList } from './BlogList/BlogList';
import { BlogPost } from './BlogPost/BlogPost';

const GeneratorWrapper = () => {

    return (
        <Routes>
            <Route
                path=""
                element={
                    <BlogProvider><BlogList /></BlogProvider>
                }
            />
            <Route
                path=":title"
                element={
                    <BlogProvider><BlogPost /></BlogProvider>
                }
            />
        </Routes>
    );
};

export default GeneratorWrapper;
